import { FormattedMessage } from '@lm/intl'
import type { ReactNode } from 'react'
import {
  ErrorBoundary as ReactErrorBoundary,
  type FallbackProps,
} from 'react-error-boundary'

import { DEV_ENV } from '../../configurations'
import { Warning } from '../Warning/Warning'
import { Wave } from '../Wave/Wave'

export type ErrorBoundaryProps = {
  children: ReactNode
  noFallback?: boolean
}

export function ErrorBoundary({ children, noFallback }: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary FallbackComponent={noFallback ? NoFallback : Fallback}>
      {children}
    </ReactErrorBoundary>
  )
}

const Fallback = ({ error }: FallbackProps) => {
  if (DEV_ENV) {
    return (
      <div
        className='flex items-center p-4 border-t-4 dark:text-red-400 bg-gray-800 border-red-800 w-full'
        role='alert'
      >
        <div className='ms-3 text-sm font-medium'>
          {'Error: '}
          {(error as Error | undefined)?.message ?? String(error)}
        </div>
      </div>
    )
  }

  return (
    <div className='flex flex-col items-center'>
      <h1 className='lm__title--page font-extrabold uppercase text-center text-silverChalice mt-10 mb-6'>
        <FormattedMessage id='global.error.title' />
      </h1>

      <h2 className='lm__title--sub font-extrabold text-center w-4/5 mb-14'>
        <FormattedMessage id='global.error.subtitle' values={{ br: <br /> }} />
      </h2>

      <Warning className='mb-14' />

      <Wave direction='up' peakCount={2} height={15} />
      <Wave direction='up' peakCount={3} height={0} color='lightSilver' />
    </div>
  )
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NoFallback = (_props: FallbackProps) => <></>
